// Include tinyMCE library

import {loadScriptWithCallback} from "../plugins/script-loader/script-loader.js";

class TinyMCE {
    constructor() {
        if (TinyMCE.instance == null) {
            this.editors = {};
            this.url = `${APPLICATION}/js/tinymce_464/tinymce.min.js`;
            TinyMCE.instance = this;
        }

        return TinyMCE.instance;
    }

    /**
     * @param {string} selector
     * @param {object} [options={}]
     * @param {boolean} [options.readonly=false]
     * @param {boolean} [options.simple=false]
     * @param {boolean} [options.ondemand=false]
     */
    add(selector, options = {}) {
        return new Promise((resolve, reject) => {
            const baseFont = options.fontFamily || 'Arial, Helvetica, sans-serif'; // default content font

            const config = {
                selector,
                custom_elements: ['gallery,glyphtextblock,list,glyphslider'],
                plugins: [
                    "advlist autolink autosave link image lists charmap print preview hr anchor pagebreak spellchecker",
                    "searchreplace wordcount visualblocks visualchars code fullscreen importcss insertdatetime media nonbreaking",
                    "table contextmenu directionality emoticons template textcolor paste textcolor colorpicker textpattern elatusPlaceholder glyphtextblock glyphSlider"
                ],
                file_browser_callback: (field_name, url, type, win) => {
                    tinymce.activeEditor.windowManager.open({
                        file: `${APPLICATION}/filemanager?hidenav=yes&element=` + field_name + "&url=" + url,
                        title: 'Select an Image',
                        width: 1000,
                        height: 550,
                        resizable: "yes",
                        inline: "yes",
                        close_previous: "yes"
                    }, {
                        window: win,
                        input: field_name
                    });

                    return false;
                },
                content_style: [
                    `body.mce-content-body{font-family:${baseFont}; font-size:14px; line-height:1.6;}`,
                    `h1,h2,h3,h4,h5,h6{font-family:${baseFont};}`
                ].join('\n'),
                content_css: false,
                toolbar_items_size: 'small',
                readonly: options.readonly || false,
                remove_script_host: false,
                convert_urls: false,
                relative_urls: false,
                style_formats_merge: true,
                importcss_merge_classes: false,
                importcss_append: true,
                entity_encoding: "raw",
                style_formats: [
                    {title: 'Image Styles'},
                    {title: 'Responsive image (100%)', selector: 'img', classes: 'img-responsive'},
                    {title: 'Wide Image', selector: 'img', classes: 'wide-img'},
                    {title: 'External link', selector: 'a', classes: 'external-link'},
                    {title: 'Check list', selector: 'ul', classes: 'check-list'},
                    {title: 'Dotted list', selector: 'ul', classes: 'dotted-list'},
                    {title: 'Section title', selector: 'h2', classes: 'section-title'},
                ],
                templates: `${APPLICATION}/service/allgroups/templates?type=1`,
                extended_valid_elements: "p[*],h1[*],h2[*],h3[*],h4[*],h5[*],h6[*],img[*],iframe[*],script[*],ul[*],li[*],ol[*],blockquote[*],div[*],figure[*],dl[*],dt[*],dd[*],span[*],i[*],gallery[id],list[id],glyphtextblock[*],glyphslider[id]"
            };

            if (!options.simple) {
                config.menubar = true;
                config.toolbar1 = "newdocument fullpage | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | styleselect formatselect | fontselect fontsizeselect";
                config.toolbar2 = "cut copy paste | searchreplace | bullist numlist | outdent indent blockquote | undo redo | link unlink anchor image media code | insertdatetime preview | forecolor backcolor";
                config.toolbar3 = "table | hr removeformat | subscript superscript | charmap emoticons | print fullscreen | ltr rtl | spellchecker | visualchars visualblocks nonbreaking template pagebreak customGallery glyphtextblock glyphSlider list restoredraft";
            } else{
                config.menubar = true;
                config.toolbar1= 'undo redo | styleselect | bold italic strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | ' +
                    'bullist numlist | outdent indent | link image';
            }

            if (options.ondemand) {
                this.#createOnDemandButton(config, resolve);
            } else {
                this.#initializeTinyMCE(config, resolve);
            }
        });
    }

    /**
     *
     * @param config
     * @param resolve
     */
    #initializeTinyMCE(config, resolve) {
        loadScriptWithCallback(this.url, () => {
            config.setup = (editor) => {
                this.editors[config.selector] = editor;

                editor.on("keyup init", () => {
                    const textarea = $(`#${tinymce.activeEditor.id}`);
                    const content = tinymce.activeEditor.getContent();
                    const stripedValue = content.replace(/(<([^>]+)>)/ig, "");
                    textarea.text(stripedValue);
                    textarea.trigger("keyup");
                });

                if (typeof resolve === 'function') {
                    resolve(editor);
                }
            };

            tinymce.init(config);
        });

    }

    /**
     * Creates an "Initialize Editor" button for on-demand loading
     * @param {object} config
     * @param resolve
     */
    #createOnDemandButton(config, resolve) {
        const $parent = $(config.selector).closest(".form-group");
        const $button = $('<button class="btn btn-sm btn-secondary tinymce-loader"><i class="bi bi-pencil-square"></i></button>');

        $button.on("click", (e) => {
            e.preventDefault();
            this.#initializeTinyMCE(config, (editor) => {
                $button.remove();
                resolve(editor);
            });
        });

        $parent.append($button);
    }


    getContent(id) {
        return this.editors[id]?.getContent() || '';
    }

    setContent(id, content) {
        this.editors[id]?.setContent(content);
    }
}

export default TinyMCE;
